import React, { useState } from "react";
import backgroundGradient from "../assets/images/background-gradient.svg";
import logo from "../assets/images/logo.png";
import heroArt from "../assets/images/hero-art.png";
import stylesGlobal from "../styles/stylesHeroGlobal";
import stylesDesktop from "../styles/stylesHeroDesktop";
import { card1Animation, card2Animation } from "../animations/heroCardAnimations";
import card1Gradient from "../assets/images/gradient-card-1.svg";
import card2Gradient from "../assets/images/gradient-card-2.svg";
import { card1Frames } from "../animations/heroCardAnimations";
import useHeroLogic from "../hooks/useHeroLogic";

function HeroDesktop() {
  const [isHovered, setIsHovered] = useState(false);
  const { card1CurrentFrame, heroRef } = useHeroLogic();

  return (
    <section id="hero" ref={heroRef} style={stylesGlobal.heroContainer}>
      <img src={backgroundGradient} alt="Background Gradient" style={stylesGlobal.background} />

      <div style={stylesDesktop.contentContainer}>
        <div style={stylesDesktop.textContainer}>
          <img src={logo} alt="Logo" style={stylesDesktop.logo} />
          <h1 style={stylesDesktop.heading}>
            Soluções digitais que <span className="highlight">impulsionam</span> o seu negócio
          </h1>
          <p style={stylesDesktop.subheading}>
            Aceleramos sua modernização com <span style={stylesDesktop.subheadingHighlight}>estratégia</span>,<br />
            <span style={stylesDesktop.subheadingHighlight}>design</span> e <span style={stylesDesktop.subheadingHighlight}>desenvolvimento</span> sob medida.
          </p>
          <img
            src={heroArt}
            alt="Hero Art"
            style={{
              ...stylesDesktop.heroArt,
              ...(isHovered ? stylesDesktop.heroArtHover : {}),
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
        </div>

        <div style={stylesDesktop.cardsContainer}>
        <div style={stylesDesktop.card1Placeholder}>
            <img
              src={card1Gradient}
              alt="Card Gradient"
              style={stylesDesktop.cardGradient}
            />

            <div style={stylesDesktop.cardBlur}></div>

            <img
              alt="Card 1 Animation"
              style={{
                ...stylesDesktop.animatedImage,
                ...card2Animation,
              }}
            />
          </div>
          
          <div style={stylesDesktop.card2Placeholder}>
            <img
              src={card2Gradient}
              alt="Card Gradient"
              style={stylesDesktop.cardGradient}
            />

            <div style={stylesDesktop.cardBlur}></div>

            <img
              src={card1Frames[card1CurrentFrame]}
              alt="Card 1 Animation"
              style={stylesDesktop.animatedImage}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroDesktop;
